import { AmiraResources } from "@/models";

export const getSkillResources = ({
  skillId,
  skillResources,
  lessonName,
  curriculumName,
}: {
  skillId: string;
  skillResources: { skillId: string; resources: AmiraResources[] }[];
  lessonName: string;
  curriculumName: string;
}) => {
  if (skillResources.length === 0 || skillId.length === 0) {
    return [];
  }
  let resources: AmiraResources[] = [];
  if (
    skillResources.length &&
    skillId &&
    skillResources.find(s => s.skillId === skillId)
  ) {
    resources =
      skillResources.find(s => s.skillId === skillId)?.resources || [];
  }
  if (resources.length > 0) {
    // filter resources by tags related to the lesson
    resources = resources.filter(r => {
      if (r.tags.includes(`LESSONNAME-${lessonName}`)) {
        return true;
      }
      if (
        r.tags.includes(`CURR-${curriculumName}`) &&
        !r.tags.find(t => t.startsWith("LESSONNAME-"))
      ) {
        return true;
      }
      if (r.tags.includes("SKILLDEFAULT-ASSIGNED")) {
        return true;
      }
      if (r.tags.length === 1 && r.tags.includes(`SKILL-${skillId}`)) {
        return true;
      }
      if (r.tags.length === 0) {
        return true;
      }
      return false;
    });
  }
  return resources;
};
